import React, { memo } from 'react';

import { Box } from '@mui/material';

const testAreEquals = ( prevProps, nextProps ) => {
  if (prevProps.feature !== nextProps.feature) {
    return false;
  }
  return true;
};

const SelectedFeatureGraph = ({feature, CardInfoGraph}) => {
  const style = {
    cardBase: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center'
    }
  };


  return (
    <Box sx={style.cardBase}>
      <CardInfoGraph selectedGraph={feature} />
    </Box>
  );
};

export const SelectedGraphDetails = memo(SelectedFeatureGraph, testAreEquals);